import { Helper } from '@/mixin/helper'
import store from '@/state/store'

export default [
  {
    path: '/videohistory-3/download',
    name: 'Video History 3 Download',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (store.getters['identity/hasAccessAll'](['b3h-new-trackvision-menu:read'])) {
          next({ name: 'Liveview' })
          return
        }
        if (store.getters['identity/hasAccessAll'](['b3d-pelacakan-video-new:read'])) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () => import('@/router/views/videohistory-3/download'),
  },
  {
    path: '/videohistory-3/:vehicleId?',
    name: 'Video History 3',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        if (store.getters['identity/hasAccessAll'](['b3h-new-trackvision-menu:read'])) {
          next({ name: 'Liveview' })
          return
        }
        Helper.methods.userLogging('Access', _)
        if (store.getters['identity/hasAccessAll'](['b3d-pelacakan-video-new:read'])) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () => import('@/router/views/videohistory-3/'),
  },
]
